import React from "react";
import styles from "./AddHiddenItemForm.module.scss";
import classnames from "classnames";

export default function SelectableManufacturerDisplay({
  manufacturer,
  onSelect,
  "data-testid": dataTestId,
}) {
  return (
    <div
      className={classnames(styles.selectableItem, {
        [styles.selectable]: !!onSelect,
      })}
      onClick={onSelect}
      data-testid={dataTestId}
    >
      {manufacturer.name} (All products from this manufacturer)
    </div>
  );
}
